/* global module */
/* eslint react/no-unused-prop-types: 1 */

import React from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import LayoutComponent from '../layout/layout.component';
import Types from '../../types';
import { initializeHistory } from '../../lib/routerHelper';

class ApplicationComponent extends React.Component {

  getChildContext() {
    return {
      i18n: this.props.i18n,
    };
  }

  componentWillMount() {
    initializeHistory(
      this.context.router.history,
      this.props.i18n,
      this.props.store,
    );
  }

  render() {
    return (
      <Provider store={this.props.store}>
        <LayoutComponent />
      </Provider>
    );
  }
}

ApplicationComponent.propTypes = {
  i18n: PropTypes.object.isRequired,
  store: PropTypes.shape({}),
};

ApplicationComponent.childContextTypes = {
  i18n: Types.I18n.isRequired,
};

ApplicationComponent.contextTypes = {
  router: PropTypes.shape({
    history: Types.RouterHistory.isRequired,
  }),
};

export default props => (
  <BrowserRouter>
    <ApplicationComponent {...props} />
  </BrowserRouter>
);
